module.exports = __webpack_public_path__ + "static/ab6-2df0d8921889852ecb8590f0eba788d2.jpg";